import React from 'react';
import PropTypes from 'prop-types';

import styles from './practiceoffline.module.css';
import { ReactComponent as Arrow } from '../../../svgs/close.svg';
import icon from '../../../svgs/pharmacy-error.svg';
import CallPractice from '../../../components/CallPractice/index';
import { practicePropType } from '../../../PracticesPage/propTypes/index';

const PracticeOffline = ({ practice, arrowClick }) => (
  <div className={styles.container}>
    <Arrow className={styles.arrow} onClick={arrowClick} />
    <div className={styles.whoops}>Whoops!</div>
    <div className={styles.popUpContainer}>
      <div className={styles.popUp}>
        <img src={icon} alt="hospital" className={styles.icon} />
        <div className={styles.message}>
          Vensa online prescription service is temporarily unavailable.
          <br />
          <br />
          Please check back later to request your medication.
          <br />
          <br />
          We're working on getting things back up and running!
          <br />
        </div>
      </div>
    </div>
  </div>
);

PracticeOffline.propTypes = {
  practice: practicePropType,
  arrowClick: PropTypes.func.isRequired,
};

export default PracticeOffline;
